var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tab-adj-neg"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{staticClass:"b-tab scroll",attrs:{"pills":"","card":"","vertical":""}},[_c('word-card-adj-neg',{attrs:{"id":"tab","itemData":_vm.item,"arrData":_vm.arr,"per-page":_vm.perPage,"current-page":_vm.currentPage}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48070c60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Karon/negrelatedword/TabAdjNeg.vue
// module id = null
// module chunks = 